export default {
  namespaced: true,
  state: {
    patient: {
      uuid: '',
      photo: '',
      fullName: '',
      cpf: '',
      phone: '',
      startTime: '',
      endTime: '',
      attendanceTime: '',
      age: '',
      sex: '',
      birthDate: '',
      address: '',
      city: '',
    },
  },
  mutations: {
    setPatient(state, patient) {
      state.patient = patient
    },
  },
  actions: {
    updatePatient({ commit }, patient) {
      commit('setPatient', patient)
    },
  },
  getters: {
    patient: state => state.patient,
  },
}
